import { createFileRoute, useSearch } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { ClipResultsCanvas } from '@/features/app-shell/canvases/clip-results-canvas'

type ClipResultsSearch = {
  taskId: string
  title?: string
  src?: string
  style?: string
  language?: string
  orientation?: string
  resolution?: string
}

export const Route = createFileRoute('/app/clip-results')({
  validateSearch: (search: Record<string, unknown>): ClipResultsSearch => ({
    taskId: typeof search.taskId === 'string' ? search.taskId : '',
    title: typeof search.title === 'string' ? search.title : undefined,
    src: typeof search.src === 'string' ? search.src : undefined,
    style: typeof search.style === 'string' ? search.style : undefined,
    language: typeof search.language === 'string' ? search.language : undefined,
    orientation: typeof search.orientation === 'string' ? search.orientation : undefined,
    resolution: typeof search.resolution === 'string' ? search.resolution : undefined,
  }),
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: ClipResultsRoute,
})

function ClipResultsRoute() {
  const search = useSearch({ from: '/app/clip-results' })
  return (
    <ClipResultsCanvas
      taskId={search.taskId}
      title={search.title}
      src={search.src}
      style={search.style}
      orientation={search.orientation}
      resolution={search.resolution}
    />
  )
}
